/* premium-video セクションの遅延読み込み＋配信方式の選択。

   もともとは Shopify の video_tag が 1080p mp4(41.7MB) を1本だけ出力し、
   autoplay のためページを開いた瞬間に全体のダウンロードが始まっていた。
   スマホの表示速度と通信量を大きく損ねていたため、以下の2点で抑える。

     1. 画面に近づくまで一切ダウンロードしない
        （preload="none" + IntersectionObserver）
     2. 端末に見合う配信方式を選ぶ
        ・HLS(m3u8) を再生できる端末（iOS / Safari）は HLS を使う。
          マスタープレイリストに 480p / 720p / 1080p が入っており、
          セグメント配信なので全体をダウンロードせず回線に応じて解像度も自動で下がる。
        ・再生できない端末は mp4 にフォールバックする。
          canPlayType は環境によって当てにならないため、実際に error が出たら
          mp4 に切り替える方式にしている。

   ポスター画像は最初から表示されるため、見た目は従来と変わらない。 */

(function () {
  'use strict';

  var videos = document.querySelectorAll('video[data-premium-video]');
  if (!videos.length) return;

  var list = Array.prototype.slice.call(videos);

  function parseSources(video) {
    try {
      var parsed = JSON.parse(video.dataset.sources || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function pickMp4(mp4s, displayWidth) {
    // 装飾用のループ動画なので、画質よりも通信量を優先して控えめに選ぶ。
    var needed;
    if (displayWidth <= 500) {
      needed = 480;
    } else if (displayWidth <= 900) {
      needed = 720;
    } else {
      needed = 1080;
    }

    var sorted = mp4s.slice().sort(function (a, b) {
      return a.height - b.height;
    });

    for (var i = 0; i < sorted.length; i++) {
      if (sorted[i].height >= needed) return sorted[i].url;
    }
    return sorted[sorted.length - 1].url;
  }

  function mp4Url(video, sources) {
    var mp4s = sources.filter(function (s) {
      return s && s.url && s.format === 'mp4';
    });
    if (!mp4s.length) return null;
    var width = video.getBoundingClientRect().width || window.innerWidth;
    return pickMp4(mp4s, width);
  }

  function tryPlay(video) {
    if (video.dataset.autoplay !== 'true') return;
    // Safari / iOS は muted でないと自動再生を拒否する
    video.muted = true;
    var played = video.play();
    if (played && typeof played.catch === 'function') {
      played.catch(function () {
        /* 自動再生がブロックされてもポスター画像が残るため問題なし */
      });
    }
  }

  function activate(video) {
    if (video.dataset.loaded === '1') return;

    var sources = parseSources(video);
    if (!sources.length) return;

    var hls = null;
    for (var i = 0; i < sources.length; i++) {
      if (sources[i] && sources[i].url && sources[i].format === 'm3u8') {
        hls = sources[i];
        break;
      }
    }

    var fallback = mp4Url(video, sources);
    var canTryHls = hls && video.canPlayType('application/vnd.apple.mpegurl') !== '';

    if (!canTryHls && !fallback) return;

    video.dataset.loaded = '1';

    if (canTryHls) {
      // canPlayType が "maybe" でも実際には再生できない環境があるため、
      // 失敗したら一度だけ mp4 に切り替える。
      if (fallback) {
        video.addEventListener(
          'error',
          function onHlsError() {
            video.removeEventListener('error', onHlsError);
            video.src = fallback;
            video.load();
            tryPlay(video);
          },
          { once: true }
        );
      }
      video.src = hls.url;
    } else {
      video.src = fallback;
    }

    video.load();
    tryPlay(video);
  }

  function nearViewport(video) {
    var rect = video.getBoundingClientRect();
    var margin = 300;
    return rect.top < window.innerHeight + margin && rect.bottom > -margin;
  }

  function sweep() {
    var remaining = false;
    list.forEach(function (video) {
      if (video.dataset.loaded === '1') return;
      if (nearViewport(video)) {
        activate(video);
      } else {
        remaining = true;
      }
    });
    return remaining;
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          activate(entry.target);
          observer.unobserve(entry.target);
        });
      },
      // 画面に入る少し手前で読み込み始め、スクロール到達時には再生済みにする
      { rootMargin: '300px 0px' }
    );

    list.forEach(function (video) {
      observer.observe(video);
    });
  }

  // IntersectionObserver が無い / 何らかの理由で発火しない環境でも
  // 動画が永久に読み込まれないままにならないようにする保険。
  var onScroll = function () {
    if (!sweep()) {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  sweep();
})();
